import proj4 from 'proj4';

const CoordUtils = {
  projWGS84: ['EPSG:4326', '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs'],
  projUTMK: ['EPSG:5179', '+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs'],

  // 각도좌표계에서 직각좌표계로 변환되는 함수
  transWGS84ToUTMK(coords) {
    return proj4(this.projWGS84[0], this.projUTMK[1], coords);
  },
  // 직각좌표계에서 각도 좌표계로 변환하는 함수
  transUTMKToWGS84(coords) {
    return proj4(this.projUTMK[1], this.projWGS84[0], coords);
  }
};

export default CoordUtils;
